export default __webpack_public_path__ + "static/media/page13.874ada41.webp";